import { ApiError } from "@/lib/api/client";

// ErrorState is the generic "query failed" panel used across list/detail
// pages. It surfaces the API code so users (and screenshots) carry enough
// info to debug.

export interface ErrorStateProps {
  error: unknown;
  retry?: () => void;
}

export function ErrorState({ error, retry }: ErrorStateProps) {
  const message =
    error instanceof ApiError
      ? `${error.message} (${error.code})`
      : error instanceof Error
        ? error.message
        : String(error);
  return (
    <div className="rounded-md border border-destructive/40 bg-destructive/5 px-4 py-3 text-sm">
      <p className="font-medium text-destructive">Something went wrong.</p>
      <p className="mt-1 text-destructive/80">{message}</p>
      {retry && (
        <button
          className="mt-2 text-xs underline hover:no-underline"
          onClick={retry}
        >
          Try again
        </button>
      )}
    </div>
  );
}
